import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing, containers } = lightTheme;

const cellStyles: SxProps = {
  borderBottom: '0',
  textAlign: 'center',
  padding: {
    xs: spacing(0.25),
    md: spacing(0.5)
  }
};

const styles: Record<string, SxProps> = {
  container: {
    ...containers.type2,
    paddingX: {
      ...(containers.type2?.paddingX || {}),
      xs: spacing(0.5) // half of container.type2.paddingX.xs
    },
    backgroundColor: palette.lightishAqua[500]
  },

  title: {
    color: palette.primary.main
  },

  description: {
    paddingY: spacing(1)
  },

  table: {
    tableLayout: 'fixed',
    th: {
      backgroundColor: palette.common.white,
      verticalAlign: 'bottom'
    },
    width: {
      xs: '100vw',
      md: '100%'
    },
    ml: {
      xs: spacing(-0.5),
      md: 0
    }
  },

  tableBodyRow: {
    '&:nth-of-type(even)': {
      backgroundColor: palette.common.white
    },
    'td:first-child': {
      paddingLeft: spacing(0.5)
    }
  },

  highlight: {
    ...cellStyles,
    backgroundColor: palette.primary.main,
    color: palette.common.white
  },

  textCell: {
    ...cellStyles,
    textAlign: 'left',
    width: '35%'
  },

  headerColumnCellText: {
    fontWeight: '500'
  },

  normal: {
    ...cellStyles,
    color: palette.primary.main
  },

  crossIcon: {
    width: '1rem'
  },

  buttonsRow: {
    backgroundColor: palette.common.white,
    display: {
      xs: 'none',
      md: 'table-row'
    }
  },

  desktopButtons: {
    a: {
      minWidth: 'auto'
    }
  },

  mobileButtons: {
    my: spacing(0.5),
    display: {
      xs: 'block',
      md: 'none'
    }
  }
};

export default styles;
